import { Controller } from "@hotwired/stimulus"

// Keeps Drilling visibly distinct from ordinary area filing inside the shared
// save sheet. A full list turns the switch-on action into an explicit swap.
export default class extends Controller {
  static targets = [
    "main", "replacement", "checkbox", "count", "status", "statusText",
    "replacementChoice", "replaceButton"
  ]

  static values = {
    count: Number,
    full: Boolean,
    current: Boolean
  }

  connect() {
    this.updateSummary()
  }

  toggle() {
    if (this.checkboxTarget.checked && this.fullValue && !this.currentValue && !this.selectedReplacement) {
      this.showReplacement()
      return
    }

    this.updateSummary()
  }

  chooseReplacement(event) {
    this.replacementChoiceTargets.forEach((row) => row.classList.remove("is-selected"))
    event.currentTarget.classList.add("is-selected")
    event.currentTarget.querySelector("input[type='radio']").checked = true
    this.replaceButtonTarget.disabled = false
  }

  confirmReplacement() {
    this.checkboxTarget.checked = true
    this.showMain()
    this.updateSummary()
  }

  back() {
    this.replacementChoiceTargets.forEach((row) => {
      row.classList.remove("is-selected")
      row.querySelector("input[type='radio']").checked = false
    })
    this.replaceButtonTarget.disabled = true
    this.checkboxTarget.checked = false
    this.showMain()
    this.updateSummary()
  }

  showReplacement() {
    this.mainTarget.hidden = true
    this.replacementTarget.hidden = false
  }

  showMain() {
    this.replacementTarget.hidden = true
    this.mainTarget.hidden = false
  }

  updateSummary() {
    const enabled = this.checkboxTarget.checked
    const selected = this.selectedReplacement
    const changedCount = this.currentValue
      ? this.countValue - (enabled ? 0 : 1)
      : this.countValue + (enabled && !selected ? 1 : 0)
    this.countTarget.textContent = `${changedCount} of 3`
    this.checkboxTarget.closest(".drilling-picker-toggle").classList.toggle("is-on", enabled)

    let message = ""
    if (enabled && selected) message = `Will replace “${selected.dataset.label}” in Drilling`
    else if (enabled && this.currentValue) message = "Currently in Drilling"
    else if (enabled) message = "Will be added to Drilling"
    else if (this.currentValue) message = "Will be removed from Drilling"

    this.statusTextTarget.textContent = message
    this.statusTarget.hidden = message.length === 0
  }

  get selectedReplacement() {
    return this.replacementChoiceTargets.find((row) => row.querySelector("input[type='radio']").checked)
  }
}
